import React from 'react';

// GraphQl
import { useQuery } from '@apollo/react-hooks';

// Components & Others
import PropTypes from 'prop-types';
import { useHistory, useParams } from 'react-router-dom';
import LoadingIndicator from '../../../LoadingIndicator';
import NewsForm from '../NewsForm';
import { GET_NEWS } from '../queries';

function NewsEdit() {
  const { id } = useParams();
  const history = useHistory();
  const { loading, error, data } = useQuery(GET_NEWS, {
    variables: { id },
  });
  if (loading) return <LoadingIndicator />;
  if (error) {
    console.error('get news', error);
    history.goBack();
  }

  const formatValue = { ...data.news };
  if (!data.news) {
    history.goBack();
  }

  return <NewsForm news={formatValue} id={id} isEdit />;
}

NewsEdit.propTypes = {};

export default NewsEdit;
